import React from 'react';

export default class PipedContentFooter extends React.Component {

  render() {
    var sectionClass = (this.props.section)
      ? this.props.section
      : ''
    ;

    return (
      <div className={`PipedContentFooter row ${sectionClass}`}>
        <div className="col-xs-16">
          <div className="strokes">
            <div className="stroke-mask left"></div>
            <div className="stroke-mask right"></div>
            <div className="stroke horizontal"></div>
            <div className="stroke vertical left"></div>
            <div className="stroke vertical right"></div>
          </div>
        </div>
      </div>
    );
  }

};
